import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
}

interface State {
  isShow: boolean;
}

export class NoRewardPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0.02 }}
                end={{ x: 0, y: 0.31 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(26)} />
                <Image
                  style={styles.noChance}
                  source={require('../../images/invite/noChance.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={rpx(30)} />
                <EmTouchableOpacity
                  style={styles.taskBtn}
                  activeOpacity={0.9}
                  onPress={() => {
                    onPress && onPress();
                  }}
                >
                  <Image
                    style={styles.taskBtn}
                    source={require('../../images/invite/doTask.png')}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
                <Spacer size={rpx(20)} />
              </LinearGradient>
              <EmTouchableOpacity
                onPress={() => {
                  this.hide();
                }}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99,
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    alignItems: 'center',
    borderRadius: rpx(32),
  },
  text: {
    fontSize: rpx(15),
    color: '#333333',
    lineHeight: rpx(24),
    fontWeight: 'bold',
  },
  noChance: {
    width: rpx(214),
    height: rpx(57.5),
    zIndex: 11,
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
  taskBtn: {
    width: rpx(210),
    height: rpx(50),
  },
});
